import React from "react"
import {
    AppNotificationsDrawerProvider,
    AppMainHotelsProvider,
    AppLastUpdateProvider,
    AppCurrencyProvider,
    AppMarketProvider,
    AppDatesProvider,
    AppRefreshDataProvider,
    AppLocationDataProvider
} from "./@contexts"


export default function AppProviders({ children }) {
    
    return (
        <AppNotificationsDrawerProvider>
            <AppMainHotelsProvider>
                <AppLastUpdateProvider>
                    <AppCurrencyProvider>
                        <AppMarketProvider>
                            <AppDatesProvider>
                                <AppRefreshDataProvider>
                                    <AppLocationDataProvider>
                                        {children}
                                    </AppLocationDataProvider>
                                </AppRefreshDataProvider>
                            </AppDatesProvider>
                        </AppMarketProvider>
                    </AppCurrencyProvider>
                </AppLastUpdateProvider>
            </AppMainHotelsProvider>
        </AppNotificationsDrawerProvider>
    )
}

export {
    AppCurrencyContext, AppMainHotelsContext, AppDatesContext,
    AppLastUpdateContext, AppMarketContext,
    AppNotificationsDrawerContext, AppRefreshDataContext, AppLocationDataContext
} from "./@contexts"
